// extracted by mini-css-extract-plugin
module.exports = {"property":"Property_property__1xtt7","propertyName":"Property_propertyName__s8_xo","info":"Property_info__3nGwo"};